var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDislike = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.867 4.5a3.25 3.25 0 0 1 3.083 2.222l1.088 3.265A1.53 1.53 0 0 1 15.588 12H11.75a.75.75 0 0 0-.742.856l.46 3.23c.018.117.02.235.006.353-.072.647-.94.852-1.29.281a110.855 110.855 0 0 0-1.81-2.886 6.127 6.127 0 0 0-1.852-1.782A6.19 6.19 0 0 0 6 11.759V4.5h6.867ZM4.5 4.5v7h-.75c-.69 0-1.25-.56-1.25-1.25v-4.5c0-.69.56-1.25 1.25-1.25h.75Zm.61 8.5H3.75A2.75 2.75 0 0 1 1 10.25v-4.5A2.75 2.75 0 0 1 3.75 3h9.117a4.75 4.75 0 0 1 4.506 3.248l1.088 3.265a3.03 3.03 0 0 1-2.873 3.987h-2.973l.339 2.373c.034.243.038.488.011.732-.231 2.084-2.973 2.672-4.06.899a109.704 109.704 0 0 0-1.779-2.838 4.627 4.627 0 0 0-1.399-1.343A4.54 4.54 0 0 0 5.112 13Z",
    fill: "currentColor"
  })));
};
export default SvgDislike;